import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { useLazyQuery } from "@apollo/client";

import * as categoryAction from "../../../app/NewRedux/Categories/categoryAction";
import * as actions from "../../../app/Pages/Dashboard/_redux/dashboardActions";
import EquipBidHeader from "../../Components/EquipbidHeader";
import EquipBidFooter from "../../Components/Footer";
import {
  LIST_CATEGORIES_BY_PRIORITY,
  LIST_FEATURED_ASSET,
} from "../../Pages/Client/Category/graphql/query";
import { EQUIPBID_CATEGORIES } from "../../Utils/dummyData";
import { base64Encode, page360Url } from "../../Utils/helper";

import Equipment from "./Equipment";
import HomeV2 from "./homeV2";

export default function HomePage() {
  const dispatch = useDispatch();

  const history = useHistory();

  const [user, setUser] = useState();

  const [selectedHeaderTab, setSelectedHeaderTab] = useState("");

  const [filterSelectedData, setFilterSelectedData] = useState({
    tabs: [],
    category: [],
    makes: [],
    models: [],
  });

  const [stepperState, setStepperState] = useState(0);

  useEffect(() => {
    getCategories();
    getFeaturedAssets();
    window.scrollTo(0, 0);
  }, [getCategories, getFeaturedAssets]);

  const [
    getCategories,
    {
      loading: categoriesLoading,
      error: categoriesError,
      data: categoriesData,
    },
  ] = useLazyQuery(LIST_CATEGORIES_BY_PRIORITY, {
    fetchPolicy: "no-cache",
  });

  const [
    getFeaturedAssets,
    {
      loading: getFeaturedAssetsLoading,
      error: getFeaturedAssetsError,
      data: getFeaturedAssetsData,
    },
  ] = useLazyQuery(LIST_FEATURED_ASSET, {
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    let user = JSON.parse(window.localStorage.getItem("user"));

    if (user) {
      setUser(user);
    }
  }, [window.localStorage.getItem("user")]);

  useEffect(() => {
    getCategories();
    getFeaturedAssets();
    window.scrollTo(0, 0);
  }, [getCategories, getFeaturedAssets]);

  useEffect(() => {
    dispatch(actions.loading(categoriesLoading));
    if (categoriesData) {
      dispatch(categoryAction.list({ category: categoriesData.listCategoriesByPriority }));
    }
  }, [categoriesLoading, categoriesError, categoriesData, dispatch]);

  useEffect(() => {
    dispatch(actions.loading(getFeaturedAssetsLoading));
    if (getFeaturedAssetsData) {
      dispatch(
        actions.featuredAssetList(
          getFeaturedAssetsData.getFeatureListingOfAsset,
        ),
      );
    }
  }, [getFeaturedAssetsLoading, getFeaturedAssetsError, getFeaturedAssetsData]);

  // Getting curret state of dashboard category list from store (Redux)
  const { entities } = useSelector(
    (state) => ({ entities: state.newCategory.entities }),
    shallowEqual,
  );

  const { listLoading } = useSelector(
    (state) => ({ listLoading: state.dashboard.listLoading }),
    shallowEqual,
  );

  const { featuredAssetList } = useSelector(
    (state) => ({ featuredAssetList: state.dashboard.featuredAssetList }),
    shallowEqual,
  );

  const onHandleClick = (item) => {
    history.push({
      pathname: `/search-asset/${item.name}/${base64Encode(item.id)}`,
      state: { name: item.name, ids: base64Encode(item.id) },
    });
  };

  const callAssetDetailPage = (item) => {
    history.push({
      pathname: page360Url(item),
      state: { name: "detail", item: item },
    });
  };

  return (
    <div id="homepage-container">
      <EquipBidHeader setSelectedHeaderTab={setSelectedHeaderTab} filterSelectedData={filterSelectedData} setFilterSelectedData={setFilterSelectedData} setStepperState={setStepperState} showHeaderBottom={true} />

      {(() => {
        switch (selectedHeaderTab) {
        case "Equipment":
          return <Equipment filterSelectedData={filterSelectedData} setFilterSelectedData={setFilterSelectedData} stepperState={stepperState} setStepperState={setStepperState} />;
        case "Vehicles":
          return <Equipment filterSelectedData={filterSelectedData} setFilterSelectedData={setFilterSelectedData} stepperState={stepperState} setStepperState={setStepperState} />;
        case "Trailer":
          return <Equipment filterSelectedData={filterSelectedData} setFilterSelectedData={setFilterSelectedData} stepperState={stepperState} setStepperState={setStepperState} />;
        case "Attachment":
          return <Equipment filterSelectedData={filterSelectedData} setFilterSelectedData={setFilterSelectedData} stepperState={stepperState} setStepperState={setStepperState} />;
        case "Building":
          return <Equipment filterSelectedData={filterSelectedData} setFilterSelectedData={setFilterSelectedData} stepperState={stepperState} setStepperState={setStepperState} />;
        case "Other":
          return <Equipment filterSelectedData={filterSelectedData} setFilterSelectedData={setFilterSelectedData} stepperState={stepperState} setStepperState={setStepperState} />;
        default:
          return (
            <HomeV2
              featuredAssetList={featuredAssetList}
              callAssetDetailPage={callAssetDetailPage}
              onHandleClick={onHandleClick}
              entities={entities}
            />
          );
        }
      })()}

      <div className="home-content mx-8">
        <div className="featured-section">
          {EQUIPBID_CATEGORIES.map((_cat, idx) => (
            <div className="featured-item p-5">
              <h6 className="category-text">{_cat.name}</h6>
              <div className="icon-block ml-auto">
                <img src={_cat.icon} />
              </div>
            </div>
          ))}
        </div>
      </div>

      <EquipBidFooter />
    </div>
  );
}
